import useClevertapForSrp from '@/src/hooks/analytics/clevertap/srp'
import useSrpGtmEvent from '@/src/hooks/analytics/gtm/srp'
import useSearchResults from '@/src/hooks/srp/useSearchResults'
import type { FlightCard } from '@/src/types/flight'
import { getFlightData } from '@/src/utils/srp/flightResultsUtil'
import { getRouteSummaries } from '@/src/utils/srp/routeUtils'
import { useLocale, useTranslations } from 'next-intl'
import { useEffect } from 'react'
import { FlightResultsMobile } from './flightResults'

interface FlightResultsContainerProps {
    onBookFlight?: (flight: FlightCard) => void
    onViewDetails?: (flight: FlightCard) => void
    onSortByPrice?: () => void
    limitedView?: boolean
    limitedCount?: number
    showLoadMore?: boolean
    onLoadMore?: () => void
}

const FlightResultsWrapper: React.FC<FlightResultsContainerProps> = ({
    onBookFlight,
    onViewDetails,
    onSortByPrice,
    limitedView = false,
    limitedCount = 5,
    showLoadMore = false,
    onLoadMore
}) => {
    const locale = useLocale()
    const isArabic = locale === 'ar'
    const { pushEventToDataLayer } = useSrpGtmEvent()
    const { triggerSrpEvent } = useClevertapForSrp()
    const tFlightDetails = useTranslations('srpFlightDetails')
    const tCommon = useTranslations('common')
    const { jsons, sectors, selectedLegSortedFilteredCards, isPerPaxPricingEnabled } = useSearchResults()
    const { airline_names = {}, secs, ap = {} } = jsons || {}
    const sectionArray = Array.isArray(secs) ? secs : secs ? Object.values(secs) : []
    const summary = getRouteSummaries(sectionArray, ap, isArabic)

    useEffect(() => {
        triggerSrpEvent('Air_PageLoad', {
            page_load_time: Math.round(performance.now())
        })
        pushEventToDataLayer({
            event: 'page_view_flight_search_results',
            page_category: 'home'
        })
    }, [])

    return (
        <FlightResultsMobile
            getFlightData={flight =>
                getFlightData({
                    flight,
                    airline_names,
                    sectors: sectors!,
                    translationsFn: tCommon,
                    isPerPaxPricingEnabled
                })
            }
            sortedFilteredCards={selectedLegSortedFilteredCards}
            route={summary.join('|')}
            onBookFlight={onBookFlight}
            onViewDetails={onViewDetails}
            onSortByPrice={onSortByPrice}
            sectors={sectors}
            tFlightDetails={tFlightDetails}
            tCommon={tCommon}
            limitedView={limitedView}
            limitedCount={limitedCount}
            showLoadMore={showLoadMore}
            onLoadMore={onLoadMore}
        />
    )
}

export { FlightResultsWrapper }
export default FlightResultsWrapper
